import React from 'react'
import styled from '@emotion/styled'
import { GatsbyImage } from 'gatsby-plugin-image'

import { PROFILE_LINK_LIST } from '~/constants/profile'

import { useProfileImage } from '~/hooks/profile'

import LinkItem from './LinkItem'

export interface ProfileCardProps {
  hasIntroduce?: boolean
}

const ProfileCard: React.FC<ProfileCardProps> = ({ hasIntroduce = false }) => {
  const { profileImage } = useProfileImage()

  return (
    <Wrapper>
      <Content>
        <Image image={profileImage} alt="profile" />
        <Information>
          <Name>@1000peach</Name>

          <ul>
            {PROFILE_LINK_LIST.map(link => (
              <LinkItem key={link.name} {...link} />
            ))}
          </ul>
        </Information>
      </Content>

      {hasIntroduce && (
        <Introduce>
          안녕하세요.
          <br />
          주니어 프론트엔드 개발자 <em>천승아</em>입니다.
        </Introduce>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.section`
  padding: 45px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 20px;

  @media ${({ theme: { device } }) => device.mobile} {
    padding: 30px 0;
    align-items: center;
    column-gap: 17px;
  }
`

const Content = styled.div`
  width: min(300px, 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 20px;
`

const Name = styled.h1`
  ${({ theme: { typography } }) => typography.title4}
  font-family: 'Noto Sans KR', sans-serif;
  color: ${({ theme: { colors } }) => colors.defaultText};
`

const Information = styled.div`
  display: flex;
  flex-direction: column;

  ul {
    margin-top: 10px;
    padding-left: 5px;
  }
`

const Image = styled(GatsbyImage)`
  width: 130px;
  height: 130px;

  img {
    border-radius: 50%;
    border: 2px solid ${({ theme: { palette } }) => palette.purple};
  }

  @media ${({ theme: { device } }) => device.mobile} {
    width: 110px;
    min-width: 110px;
    height: 110px;
    margin-bottom: 10px;
  }
`

const Introduce = styled.p`
  ${({ theme: { typography } }) => typography.body3}
  line-height: 25px;
  color: ${({ theme: { colors } }) => colors.deepText};

  @media ${({ theme: { device } }) => device.mobile} {
    line-height: 22px;
  }

  em {
    font-style: normal;
    font-weight: 500;
  }
`

export default ProfileCard
